import { forwardRef, useRef } from "react";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import { Colors } from "../../config";
import { Wrapper } from "../../config/StyledComponents";
import InputLabel from "../InputLabel";
import "./datepicker.css";
import DatePickerField from "./DatePickerField";

const InputDatePicker = ({
  label,
  required,
  labelFontColor = Colors.coolGrey,
  labelFontSize = "1.125rem",
  labelFontWeight = 400,
  value,
  onChange,
  disabled,
  maxDate,
  minDate,
  width,
  format,
  placeholderText,
  helperText,
  name,
  borderRadius,
  scrollableYearDropdown,
  scrollableMonthDropdown,
  dropdownMode,
  placeHolderColor,
}) => {
  const inputRef = useRef(null);
  const CustomInput = forwardRef((props, ref) => {
    return <DatePickerField {...props} ref={ref} />;
  });
  return (
    <Wrapper>
      <InputLabel
        label={label}
        isRounded={true}
        labelFontColor={labelFontColor}
        labelFontSize={labelFontSize}
        labelFontWeight={labelFontWeight}
        required={required}
      />
      <DatePicker
        selected={value}
        onChange={(date) => {
          onChange(date);
        }}
        customInput={
          <CustomInput
            placeholderText={placeholderText}
            width={width}
            inputRef={inputRef}
            helperText={helperText}
            label={label}
            name={name}
            borderRadius={borderRadius}
            placeHolderColor={placeHolderColor}
          />
        }
        dateFormat={format || "dd MMM yyyy"}
        maxDate={maxDate}
        minDate={minDate}
        disabled={disabled}
        showYearDropdown={true}
        showMonthDropdown={true}
        dropdownMode={dropdownMode}
      />
    </Wrapper>
  );
};

export default InputDatePicker;
